"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UINumberInput = _interopRequireDefault(require("UIComponents/input/UINumberInput"));

var FilterNumberInput =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterNumberInput, _PureComponent);
  (0, _createClass2.default)(FilterNumberInput, null, [{
    key: "propTypes",
    get: function get() {
      return {
        labelConfig: _react.PropTypes.object,
        onBlur: _react.PropTypes.func.isRequired,
        onChange: _react.PropTypes.func.isRequired,
        value: _react.PropTypes.number
      };
    }
  }]);

  function FilterNumberInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FilterNumberInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilterNumberInput).call(this, props));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.validateInput = _this.validateInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.getValidationMessage = _this.getValidationMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isInputValid: true
    };
    return _this;
  }

  (0, _createClass2.default)(FilterNumberInput, [{
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "AudienceTargeting." + suffix;
    }
  }, {
    key: "validateInput",
    value: function validateInput(value) {
      var isInputValid = Boolean(value > 0);
      this.setState({
        isInputValid: isInputValid
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      var onBlur = this.props.onBlur;
      var value = e.target.value;
      onBlur();
      this.validateInput(value);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.props.onChange(e);
      this.validateInput(e.target.value);
    }
  }, {
    key: "getValidationMessage",
    value: function getValidationMessage() {
      var labelConfig = this.props.labelConfig;
      var validationTextConfig;

      if (labelConfig.validation) {
        validationTextConfig = labelConfig.validation.numberValue;
      }

      if (this.state.isInputValid) return '';
      return validationTextConfig || _I18n.default.text(this.getLangKey('validations.numberValue'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          labelConfig = _this$props.labelConfig,
          value = _this$props.value;
      var placeholderConfig;

      if (labelConfig.placeholders) {
        placeholderConfig = labelConfig.placeholders.number;
      }

      var placeholder = placeholderConfig || _I18n.default.text('AudienceTargeting.placeholders.number');

      return _react.default.createElement(_UIFormControl.default, {
        className: "targeting-option__input",
        error: !this.state.isInputValid,
        validationMessage: this.getValidationMessage()
      }, _react.default.createElement(_UINumberInput.default, {
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        placeholder: placeholder,
        value: value
      }));
    }
  }]);
  return FilterNumberInput;
}(_react.PureComponent);

exports.default = FilterNumberInput;
module.exports = exports.default;